// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb[data-v-29585208],\n.breadcrumb-divider[data-v-29585208] {\n  font-size: 30px;\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = exports;
